import { useMemo } from "react";

import ToolRegulatoryQuestionnaireFormField from "./field";

export default function ToolRegulatoryQuestionnaireFormFieldGroup({
  group,
}: any) {
  const header = useMemo(() => {
    if (!group.richText.content.length) return;

    return (
      <div
        className=""
        dangerouslySetInnerHTML={{
          __html: group.richText.content,
        }}
      ></div>
    );
  }, [group.richText.content]);

  const fields = useMemo(() => {
    return group.fields.map((field: any) => {
      return (
        <ToolRegulatoryQuestionnaireFormField field={field} key={field.name} />
      );
    });
  }, [group.fields]);

  return (
    <div className="">
      {header}
      {fields}
    </div>
  );
}
